var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLottie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.903 0H8.097A8.097 8.097 0 0 0 0 8.097v15.806A8.097 8.097 0 0 0 8.097 32h15.806A8.097 8.097 0 0 0 32 23.903V8.097A8.097 8.097 0 0 0 23.903 0Z",
    fill: "#00DDB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.323 7.168c-5.516 0-7.55 3.933-9.191 7.093l-1.079 2.02c-1.74 3.352-3.037 5.388-6.382 5.388a1.582 1.582 0 1 0 0 3.163c5.516 0 7.55-3.932 9.19-7.093l1.073-2.02c1.739-3.351 3.037-5.388 6.382-5.388a1.578 1.578 0 0 0 1.463-.976 1.582 1.582 0 0 0-1.463-2.187h.007Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottie);
export default __webpack_public_path__ + "static/media/lottie.e409f89e50b43dfbf35e85ee3a06940b.svg";
export { ForwardRef as ReactComponent };